// Lecture des en-tetes de borne et de pagination poses par le serveur.
//
// POURQUOI CE FICHIER EXISTE
//
// Le backend annonce depuis la PR #57 qu'une liste est tronquee, par l'en-tete
// X-Resultats-Tronques. AUCUN code du front ne le lisait. L'utilisateur voyait donc
// une liste incomplete presentee comme complete, alors meme que le serveur venait de
// dire le contraire : l'aveu existait et n'atteignait personne.
//
// Un seul endroit pour les lire, parce que quinze ecrans doivent le faire et que
// quinze lectures recopiees finissent par diverger.
//
// ATTENTION, PIEGE DE NAVIGATEUR. Ces en-tetes ne sont lisibles que si le serveur
// les declare dans `Access-Control-Expose-Headers` (voir app/main.py). Sans cela le
// navigateur les EFFACE avant de les rendre au code de la page : `res.headers` est
// alors vide, sans erreur ni avertissement. C'etait le cas avant ce lot.

/** Ce que le serveur dit d'une reponse de liste. */
export function lireBornes(res) {
  const h = res?.headers || {};
  // axios normalise les noms en minuscules ; on ne prend pas le risque d'en dependre.
  const lire = (nom) => h[nom] ?? h[nom.toLowerCase()] ?? h[nom.toUpperCase()];

  const total = Number.parseInt(lire('x-resultats-total'), 10);
  const page = Number.parseInt(lire('x-resultats-page'), 10);
  const taille = Number.parseInt(lire('x-resultats-taille'), 10);
  const borne = Number.parseInt(lire('x-resultats-borne'), 10);

  return {
    // Pagination : le total EXACT, celui qu'aucun plafond ne connaissait.
    total: Number.isFinite(total) ? total : null,
    page: Number.isFinite(page) ? page : 1,
    taille: Number.isFinite(taille) ? taille : null,
    // Troncature : l'ecran ne pagine pas et sa lecture a mordu.
    tronque: String(lire('x-resultats-tronques')) === 'true',
    borne: Number.isFinite(borne) ? borne : null,
  };
}

/** Le nombre de pages, ou 1 quand le serveur ne pagine pas cette route. */
export function nombreDePages({ total, taille }) {
  if (!total || !taille) return 1;
  return Math.max(1, Math.ceil(total / taille));
}

export const TAILLE_PAGE = 100;
